import React, {Component} from "react";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import {removeNullFields} from "../../../common/mapper";
import FormDetailPDI from "../common/formDetailPDI";
import {defaultTableChange} from "../../../../modules/custom/customTable";
import * as R from "ramda";

class BelumPDI extends Component {
    searchOptions = [
        {
            label: "Nomor Mesin",
            value: "engineNumber",
        },
        {
            label: "Kode Varian",
            value: "variantCode",
        },
    ];

    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
                sort: false,
            },
        },
        {
            name: "salesFakturNo",
            label: "No. FJ",
            options: {sort: false},
        },
        {name: "salesFakturDate", label: "Tanggal FJ", options: {sort: false}},
        {name: "variant.kodeVariant", label: "Kode Varian", options: {sort: false}},
        {name: "variant.namaVariant", label: "Nama Varian", options: {sort: false}},
        {name: "warna.kodeWarna", label: "Kode Warna", options: {sort: false}},
        {name: "warna.namaWarnaKomersil", label: "Nama Warna", options: {sort: false}},
        {name: "engineNumber", label: "Nomor Mesin", options: {sort: false}},
        {name: "frameNumber", label: "Nomor Rangka", options: {sort: false}},
        {name: "pdiStatus", label: "Status", options: {sort: false}},
        {
            name: "pdiNo",
            label: "Aksi",
            options: {
                customBodyRender: (val) => (
                    <SimpleButton secondary={!this.props.userAccess?.createAccess} onClick={() => this.handleDetailVisibility(val)}
                                  disabled={!this.props.userAccess?.createAccess}>
                        Proses PDI
                    </SimpleButton>
                ),
                sort: false,
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            detailId: "",
            searchData: {},
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!R.isNil(prevState.detailId) && R.isNil(this.state.detailId)) {
            this.props.onFetchData(this.props.state.submittedFilterData, this.props.state.pagination.page, this.props.state.pagination.limit);
        }
        if (prevState.searchData?.key !== this.state.searchData?.key && this.state.searchData?.key === null) {
            this.setState((prevValue) => ({...prevValue, searchData: {...prevValue.searchData, value: null}}));
        }
    }

    handleDetailVisibility = (id) => {
        this.setState((prevValue) => ({...prevValue, detailId: id}));
    };

    handleSearch = () => {
        let {searchData} = this.state;
        let request;
        if (searchData?.value) {
            request = removeNullFields({
                ...this.state.searchData,
                key: this.state.searchData?.key?.value,
            });
        }

        this.props.onFetchData(request, 1, this.props.state.pagination.limit);
    };

    handleChangePage = (tableState) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: tableState.page + 1,
            },
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            pagination: {
                page: 1,
                totalData: 1,
                limit: tableState.rowsPerPage,
            },
        }));
    };

    render() {
        return (
            <div>
                <FlexView
                    vAlignContent="center"
                    hAlignContent="right"
                    style={{gap: "10px", marginBottom: "15px"}}
                >
                    <FlexView vAlignContent="center" style={{gap: "10px"}}>
                        <p>Pilih</p>
                        <SimpleDDL
                            id="select_options_nomor_mesin"
                            name="nomorMesin"
                            box="search"
                            containerclassname="margin-bottom-none width width-250px"
                            options={this.searchOptions}
                            isClearable
                            value={this.state.searchData?.key}
                            onChange={(value) =>
                                this.setState((prevValue) => ({
                                    ...prevValue,
                                    searchData: {
                                        ...prevValue.searchData,
                                        key: value,
                                    },
                                }))
                            }
                        />
                    </FlexView>
                    <FlexView vAlignContent="center" style={{gap: "10px"}}>
                        <p>Cari</p>
                        <SimpleInput
                            id="input_text_cari"
                            name="cari"
                            containerclassname="margin-bottom-none"
                            readOnly={!this.state.searchData?.key}
                            value={this.state.searchData?.value}
                            onChange={({target}) =>
                                this.setState((prevValue) => ({
                                    ...prevValue,
                                    searchData: {
                                        ...prevValue.searchData,
                                        value: target.value,
                                    },
                                }))
                            }
                        />
                    </FlexView>
                    <SimpleButton className="margin-top-5px" onClick={this.handleSearch}>
                        Cari
                    </SimpleButton>
                </FlexView>
                <SimpleDataTable
                    toCount={this.props.state.pagination.totalData}
                    data={this.props.state.belumPDIData}
                    columns={this.tableColumns}
                    rowsPerPage={this.props.state.pagination.limit}
                    page={this.props.state.pagination.page - 1}
                    options={defaultTableChange(this.handleChangePage, this.handleRowsPerPage)}
                />
                {this.state.detailId && (
                    <FormDetailPDI
                        id={this.state.detailId}
                        userAccess={this.props.userAccess}
                        kodeCabang={this.props.kodeCabang}
                        onClickClose={this.handleDetailVisibility}
                    />
                )}
            </div>
        );
    }
}

export default BelumPDI;
